'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _HomeSearch = require('./HomeSearch.scss');

var _HomeSearch2 = _interopRequireDefault(_HomeSearch);

var _reactIntl = require('react-intl');

var _DestinationSelect = require('components/General/DestinationSelect');

var _DestinationSelect2 = _interopRequireDefault(_DestinationSelect);

var _DatePicker = require('components/Calendar/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _reactRedux = require('react-redux');

var _home = require('redux/modules/home');

var homeActions = _interopRequireWildcard(_home);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  DefaultHomeSearch: {
    displayName: 'DefaultHomeSearch'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/DefaultHomeSearch.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import FontAwesome from 'react-fontawesome';


// import CustomSelect from 'components/General/FormElements/CustomSelect';
// import Calendar from 'containers/Calendar/Calendar';


// import _ from 'lodash';
// import Scroll from 'react-scroll';
// const ScrollLink = Scroll.Link;


_momentTimezone2.default.tz.setDefault('Asia/Bangkok');

var DefaultHomeSearch = _wrapComponent('DefaultHomeSearch')((_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destination: state.home.destination,
    date: state.home.date,
    isFlexibleDate: state.home.isFlexibleDate
  };
}, homeActions), _dec2 = (0, _reactCssModules2.default)(_HomeSearch2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DefaultHomeSearch, _Component);

  function DefaultHomeSearch(props) {
    (0, _classCallCheck3.default)(this, DefaultHomeSearch);

    var _this = (0, _possibleConstructorReturn3.default)(this, (DefaultHomeSearch.__proto__ || (0, _getPrototypeOf2.default)(DefaultHomeSearch)).call(this, props));

    _this.state = {
      showDatePicker: false
    };

    _this.onChangeDestination = _this.onChangeDestination.bind(_this);

    if (!(typeof _this.onChangeDestination === 'function')) {
      throw new TypeError('Value of "this.onChangeDestination" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeDestination));
    }

    _this.onChangeDate = _this.onChangeDate.bind(_this);

    if (!(typeof _this.onChangeDate === 'function')) {
      throw new TypeError('Value of "this.onChangeDate" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeDate));
    }

    _this.onChangeFlex = _this.onChangeFlex.bind(_this);

    if (!(typeof _this.onChangeFlex === 'function')) {
      throw new TypeError('Value of "this.onChangeFlex" violates contract.\n\nExpected:\n(any) => any\n\nGot:\n' + _inspect(_this.onChangeFlex));
    }

    _this.toggleDatePicker = _this.toggleDatePicker.bind(_this);

    if (!(typeof _this.toggleDatePicker === 'function')) {
      throw new TypeError('Value of "this.toggleDatePicker" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.toggleDatePicker));
    }

    _this.openMobileSearch = _this.openMobileSearch.bind(_this);

    if (!(typeof _this.openMobileSearch === 'function')) {
      throw new TypeError('Value of "this.openMobileSearch" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.openMobileSearch));
    }

    _this.search = _this.search.bind(_this);

    if (!(typeof _this.search === 'function')) {
      throw new TypeError('Value of "this.search" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.search));
    }

    return _this;
  }

  (0, _createClass3.default)(DefaultHomeSearch, [{
    key: 'onChangeDestination',
    value: function onChangeDestination(e) {
      e.target.blur();
      // this.setState({destination: e.target.value}, ()=> {
      //   if (this.state.date) {
      //     this.search();
      //   }
      // });
      this.props.setDestination(e.target.value);
    }
  }, {
    key: 'onChangeDate',
    value: function onChangeDate(date) {
      // this.setState({date, showDatePicker: false}, ()=> {
      //   if (this.state.destination) {
      //     this.search();
      //   }
      // });
      this.props.setDate(date);
      this.setState({ showDatePicker: false });
    }
  }, {
    key: 'onChangeFlex',
    value: function onChangeFlex(checked) {
      this.props.setFlexibleDate(checked);
    }
  }, {
    key: 'openMobileSearch',
    value: function openMobileSearch() {
      this.props.openMobileNavSearch();
    }
  }, {
    key: 'toggleDatePicker',
    value: function toggleDatePicker() {
      this.setState({ showDatePicker: !this.state.showDatePicker });
    }
  }, {
    key: 'search',
    value: function search() {
      var _props = this.props,
          destination = _props.destination,
          date = _props.date,
          isFlexibleDate = _props.isFlexibleDate;

      if (destination === 'Bangkok' || destination === 'Phuket' || destination === 'Chiang Mai') {
        window.location = 'https://experience.takemetour.com/' + destination;
      } else if (destination === 'Ayutthaya') {
        window.location = 'https://experience.takemetour.com/Bangkok/1?focus=ayutthaya-historical-park';
      } else if (destination === 'Kanchanaburi') {
        window.location = 'https://experience.takemetour.com/Bangkok/1?focus=kanchanaburi-death-railway';
      } else {
        var query = [];
        var base = '/to/' + (destination ? destination : 'Any');
        if (date) {
          query.push('date=' + (0, _momentTimezone2.default)(date).format('DD-MM-YYYY'));
        }
        if (date && isFlexibleDate) {
          query.push('is_flexible_date=true');
        }
        if (query.length > 0) {
          base += '?' + query.join('&');
        }
        this.props.push(base);
        this.props.logSearch('home');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var showDatePicker = this.state.showDatePicker;
      // const destinations = this.getOptions();
      // const activitiesCriteria = true;

      var _props2 = this.props,
          destination = _props2.destination,
          date = _props2.date,
          isFlexibleDate = _props2.isFlexibleDate,
          messages = _props2.messages;

      var dayDiff = (0, _momentTimezone2.default)(date).diff((0, _momentTimezone2.default)().startOf('day'), 'day');
      return _react3.default.createElement(
        'div',
        null,
        _react3.default.createElement(
          'div',
          { styleName: 'dropdown-select-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'dropdown-select' },
            _react3.default.createElement(_DestinationSelect2.default, {
              locale: this.props.locale,
              messages: {
                popular_cities: messages['nav.select_dropdown.dropdown_placeholder.popular_cities'],
                cities: messages['nav.select_dropdown.dropdown_placeholder.cities']
              },
              groupDestinationsByCountry: this.props.groupDestinationsByCountry,
              onSelect: this.onChangeDestination,
              placeholder: messages['nav.select_dropdown.dropdown_placeholder'],
              destinations: this.props.destinations
            }),
            destination ? _react3.default.createElement(
              'span',
              null,
              destination
            ) : [_react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.select_dropdown.dropdown_placeholder', key: 'des-0' }), _react3.default.createElement('div', { styleName: 'dropdown-arrow', key: 'des-1' })]
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'date-container' },
            _react3.default.createElement(
              'div',
              { styleName: 'date-input-container', onClick: this.toggleDatePicker },
              _react3.default.createElement(
                'span',
                { key: 'date-0' },
                date && dayDiff === 0 && 'Today',
                date && dayDiff === 1 && 'Tomorrow',
                date && dayDiff !== 0 && dayDiff !== 1 && (0, _momentTimezone2.default)(date).format('LL'),
                !date && _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'datepicker.any_date_c' })
              ),
              ',',
              _react3.default.createElement('div', { styleName: 'dropdown-arrow', key: 'date-1' })
            ),
            showDatePicker && _react3.default.createElement(
              'div',
              { styleName: 'calendar-container' },
              _react3.default.createElement(_DatePicker2.default, { date: date, isFlexibleDate: isFlexibleDate, onChangeDate: this.onChangeDate, onChangeFlex: this.onChangeFlex })
            )
          ),
          _react3.default.createElement(
            'a',
            { styleName: 'btn-search', onClick: this.search },
            'Search'
          )
        ),
        _react3.default.createElement(
          'div',
          { styleName: 'dropdown-select-container-mobile', onClick: this.openMobileSearch },
          _react3.default.createElement(
            'div',
            { styleName: 'dropdown-select-mobile' },
            _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'nav.select_dropdown.dropdown_placeholder' }),
            _react3.default.createElement('div', { styleName: 'dropdown-arrow' })
          )
        )
      );
    }
  }]);
  return DefaultHomeSearch;
}(_react2.Component), _class2.propTypes = {
  destinations: _react2.PropTypes.array,
  push: _react2.PropTypes.func,
  // isOpenMobileQuickSearch: PropTypes.bool,
  // openMobileQuickSearch: PropTypes.func,
  messages: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  openMobileNavSearch: _react2.PropTypes.func,
  groupDestinationsByCountry: _react2.PropTypes.bool,
  destination: _react2.PropTypes.string,
  date: _react2.PropTypes.any,
  isFlexibleDate: _react2.PropTypes.bool,
  setDate: _react2.PropTypes.func,
  setDestination: _react2.PropTypes.func,
  setFlexibleDate: _react2.PropTypes.func,
  logSearch: _react2.PropTypes.func
}, _class2.defaultProps = {
  destinations: {}
}, _temp)) || _class) || _class));

exports.default = DefaultHomeSearch;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/DefaultHomeSearch.js
// module id = 1528
// module chunks = 47